module.exports = __webpack_public_path__ + "fpo-logo.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fpo-logo.svg
// module id = 53
// module chunks = 0